// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"5ef31aa0","308":"0f2c2c28","343":"a0f83a5c","849":"19e0fa42","873":"6e541ed3","957":"8d506ff9"}[chunkId] + ".css";
};